export default __webpack_public_path__ + "static/media/cny-188-cn.d8d6b17b.webp";